import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  TemplateRef,
  EventEmitter
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";

import { Store } from "@ngrx/store";
import * as fromRootStore from "../../../reducers";

import {
  PurchaseReportService
} from "../../../services/index";

@Component({
  selector: "continuosNumber",
  templateUrl: "./continuosNumber.html"
})
export class continuosNumber implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;

  loadingIndicator: boolean = true;
  gridOptions: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "desc"
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];

  constructor(
    public store: Store<fromRootStore.State>,
    private purService: PurchaseReportService,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.columns = [
      {
        name: "Inv Amt",
        prop: "inv_amt",
        summary: "sum",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right"
      }
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
    this.getContinuosNumber();
  }


  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  getContinuosNumber(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`
    };

    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };

    this.isLoadMask = this.purService
      .getContinuosNumber(params)
      .then(function(res: any) {
        that.loadingIndicator = false;

        that.gridOptions = {
          columns: res.columns,
          data: res.sqlRes,
          loading: false
        };
      });
  }

  ngOnDestroy() {
    this.purService;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/continuosNumber/continuosNumber.ts